import React from 'react'

import styled from 'styled-components'
import {selectThemeColours} from '@/theme-colours'
import {getSessionPartnerId} from '@/partnerID'

type Props = {
}

const renderHeader = (header) => header ? <h4>{header}</h4> : null

const Section = styled.div`
  border-top: 2px solid;
  border-top-color: ${(props) => props.themeColours.primaryColour};
`

export const RawSection = ({children, header, className}: Props) => {
  const themeColour = selectThemeColours(getSessionPartnerId())
  return (
    <Section className={className + ' section'} themeColours={themeColour}>
      {renderHeader(header)}
      {children}
    </Section>
  )
}

export default RawSection



// WEBPACK FOOTER //
// ./src/elements/section.js